import angular from 'angular'
import reimbursement from './reimbursement'
import deduction from './deduction'

export default angular
    .module('input.reimburseManage', [reimbursement, deduction])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('input.reimburseManage', {
            abstract: true,
            url: '/reimburseManage',
            template: '<div ui-view></div>',
            title: '报销管理',
        })
    }])
    .name



// WEBPACK FOOTER //
// ./src/app/input/reimburseManage/index.js